import LocationManagementDialog
    from "@/views/settings/locationManagement/locationManagementDialog/LocationManagementDialog.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import {EventLocations} from "@/enums/EventLocations";

export default {
    name: "LocationManagement",
    components: {
        LocationManagementDialog,
        ConfirmDlg
    },
    data() {
        return {
            loading: true,
            disabled: false,
            search: "",
            headers: [
                {
                    text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
                    align: "start",
                    value: "name",
                    width: 400
                },
                {
                    text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Type'],
                    align: "start",
                    value: "type",
                    width: 200
                },
                {
                    text: this.$i18n.messages[this.$i18n.locale]['LocationManagement.LocationKey'],
                    value: "key",
                    sortable: false,
                    width: 200
                },
                {
                    text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Color'],
                    value: "color",
                    sortable: false,
                    width: 60
                },
                {
                    align: "end",
                    value: "id",
                    width: 100,
                    sortable: false
                }
            ],
        }
    },
    computed: {
        eventLocations() {
            return this.$store.state.eventLocationModule.eventLocations.filter(x => x.type !== EventLocations.Wing);
        },
        facility() {
            return this.$store.state.facilityModule.selectedFacility;
        }
    },
    async created() {
        await this.$store.dispatch("getEventLocations");
        this.loading = false;
    },
    methods: {
        openDialogAddLocation() {
            this.$refs.locationManagementDialog.open("addLocation", null);
        },
        updateLocation(location) {
            this.$refs.locationManagementDialog.open("updateLocation", location);
        },
        deleteLocation(item) {
            this.$refs.ConfirmDlg
                .open(null, this.$i18n.messages[this.$i18n.locale]['LocationManagement.DeleteMessage'].replace('[name]', item.name), false, '', {
                    noButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Cancel'],
                    yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Delete']
                })
                .then(async response => {
                    if (response && response.agree) {
                        await this.$store.dispatch("deleteEventLocation", item).then(async () => {
                            await this.$store.dispatch("getCareLevels");
                            this.$toast.open({
                                message: this.$i18n.messages[this.$i18n.locale]['LocationManagement.LocationSuccessfullyDeleted'],
                                type: "success"
                            });
                        })
                    }
                });
        },
        translateType(type) {
            if (this.facility.languageIso === "en-US") {
                switch (type) {
                    case EventLocations.Wing:
                        return this.$t("GeneralTranslations.Wing");
                    default:
                        return type;
                }
            }

            return type;
        }
    }
}